<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <standard-form-row>
            <div class="ant-pro-page-header-search">
              <a-input-search
                size="large"
                style="width: 80%; max-width: 522px;"
                v-model="params.where.name"
                placeholder="请输入分类名称"
                enter-button
                allow-clear
                @search="getLists()"
              />
            </div>
          </standard-form-row>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false" title="课程分类列表" class="screenfull">
      <div slot="extra">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-form :form="form" layout="inline" style="margin-bottom:15px;background:#f0f2f5;padding:15px">
        <a-form-item label="分类名称">
          <a-input
            name="name"
            v-decorator="['name', { rules: [{ required: true, message: '请输入证书分类的名称' }] }]"
          />
        </a-form-item>

        <a-form-item label="排序">
          <a-input
            name="sort"
            v-decorator="[
              'sort',
              {
                initialValue: '0'
              }
            ]"
          />
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            :loading="loading"
            v-action:add
            @click="handleSubmitForm('/courses/categories/create')"
            icon="plus"
          >
            添加
          </a-button>
        </a-form-item>
      </a-form>

      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template v-for="col in ['name', 'sort']" :slot="col" slot-scope="text, record, index, expanded">
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.id, expanded)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot="course_count" slot-scope="text">
          <a-tag color="red" style="font-weight: 600">{{ text }}</a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable" v-action:update>
              <a @click="() => handleSave(record.id)"><a-icon type="check" /> 保存</a>
              <a @click="() => handleCancel(record.id)"><a-icon type="close" /> 取消</a>
            </span>
            <span v-else v-action:update>
              <a @click="() => handleEdit(record.id)"><a-icon type="edit" /> 编辑</a>
            </span>
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="list.length"
              title="确定要删除吗？"
              @confirm="() => handleOnDelete(record.id)"
              v-action:delete
            >
              <a href="javascript:;"><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list, category } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow } from '@/components'
const fields = ['name', 'sort']
const apiList = {
    getList: '/courses/categories',
    changeState: '/courses/categories/',
    delete: '/courses/categories/',
    create: '/courses/categories/create',
    update: '/courses/categories/'
}

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        defaultSortOrder: 'descend',
        sorter: true
    },
    {
        title: '分类名称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
    },
    {
        title: '排序',
        dataIndex: 'sort',
        sorter: true,
        scopedSlots: { customRender: 'sort' }
    },
    {
        title: '课程数量',
        dataIndex: 'course_count',
        scopedSlots: { customRender: 'course_count' }
    },
    {
        title: '上次编辑时间',
        sorter: true,
        dataIndex: 'updated_at'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 150,
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'CategoryList',
    mixins: [ table, list, category ], // 使用mixins
    components: {
        TableToolBarList,
        StandardFormRow
    },
    data () {
        return {
            apiList,
            fields,
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {}
}
</script>
